
import { isEqual } from 'lodash'
import { getRouteData, postRouteStatus } from '../api.js'

import settings from '../settings.js'
import notifications from '../notifications.js'

const _vars = {
  currRouteData: undefined,
  currTotalStudents: 0,

  getRouteDataPromise: undefined,
  getRouteDataCallback: undefined,

  currApiPromise: undefined,
  currApiParams: undefined,
}

function _getRouteDataFromServer(apiParams) {
  function _responseCallback(response) {
    _vars.currRouteData = response.data
    if (_vars.getRouteDataCallback) {
      _vars.getRouteDataCallback()
    }
  }

  function _responseError(error) {
    notifications.pushError('Unable to get route data from server.', error)
  }

  if (_vars.currApiPromise === undefined || !isEqual(apiParams, _vars.currApiParams)) {
    _vars.currApiPromise = getRouteData(apiParams)
    _vars.currApiPromise.then(_responseCallback).catch(_responseError)
  }
  return _vars.currApiPromise
}

function _getRouteData(id) {
  if (_vars.currRouteData) {
    return Promise.resolve(_getRouteDataSync(id))
  }
  else {
    _vars.getRouteDataPromise = new Promise((resolve) => {
      _vars.getRouteDataCallback = function () {
        resolve(_getRouteDataSync(id))
      }
    })
    return _vars.getRouteDataPromise
  }
}

function _getRouteDataSync(id) {
  if (id === undefined) {
    return _vars.currentRouteData
  }

  return _vars.currentRouteData.find(elem => elem.db_id === id)
}

function _getRouteStatus(data) {
  return postRouteStatus(data)
}

function getNumPerPage() {
  return settings.routeList.numPerPage
}

function getCurrentPage() {
  return settings.routeList.currentPage
}

function setCurrentPage(pageNumber) {
  settings.routeList.currentPage = pageNumber
}

function _init() {
  // do nothing
}

_init()

export default {
  getRouteDataFromServer: _getRouteDataFromServer,
  getRouteData: _getRouteData,
  getRouteDataSync: _getRouteDataSync,
  getRouteStatus: _getRouteStatus,
  getNumPerPage: getNumPerPage,
  getCurrentPage: getCurrentPage,
  setCurrentPage: setCurrentPage,
}
